import { fetchJSON } from "hb/lib/fetch";
import { createConsumer, Connection } from "@rails/actioncable";

export default class OpticonChannel {
  constructor(wsUrl, wsTokenUrl, fieldLookUpCb) {
    this.wsUrl = wsUrl;
    this.wsTokenUrl = wsTokenUrl;
    this.wsReconnectAttempts = 0;
    this.connected = false;
    this.disconnecting = false;

    this.reconnectTimeoutID = null;
    this.fieldLookUpCb = fieldLookUpCb;
  }

  close() {
    this.cancelReconnectTimeout();
    this.disconnecting = true;
    this.consumer.disconnect();
  }

  buildSubscriptions() {
    this.fieldKeysWs = this.consumer.subscriptions.create(
      { channel: "FieldKeysChannel" },
      {
        connected: this.onWsConnect.bind(this),
        received: this.onWsReceive.bind(this),
        disconnected: this.onWsDisconnect.bind(this),
      },
    );
  }

  async bootstrapConsumer() {
    const response = await fetchJSON({ path: this.wsTokenUrl, method: "GET" });

    if (response.error) {
      return false;
    }

    const token = response.token;
    this.consumer = createConsumer(
      `${this.wsUrl}/external_cable?token=${token}`,
    );
    const connection = new Connection(this.consumer);
    this.consumer.connection = connection;

    try {
      this.consumer.connect();
    } catch {
      return false;
    }
    this.buildSubscriptions();

    return true;
  }

  async wsAttemptConnect() {
    if (!(await this.bootstrapConsumer())) {
      this.wsReconnectAttempts += 1;
      const reconnectIn = 1000 * Math.pow(2, this.wsReconnectAttempts);
      console.debug(`Attempting reconnect in ${reconnectIn}ms`);

      if (this.wsReconnectAttempts > 4) {
        console.debug(`Too many connection attempts, aborting`);
      } else if (!this.reconnectTimeoutId) {
        console.debug(`Scheduling reconnect attempt`);
        this.reconnectTimeoutId = setTimeout(async () => {
          this.reconnectTimeoutId = null;
          this.wsAttemptConnect();
        }, reconnectIn);
      } else {
        console.debug(
          `Reconnect attempt already scheduled`,
          this.reconnectTimeoutId,
        );
      }
    }
  }

  onWsConnect() {
    console.debug("Connected to Opticon");
    this.connected = true;
    this.reconnectTimeoutID = null;
  }

  onWsDisconnect({ willAttemptReconnect }) {
    console.debug("Disconnected from Opticon");
    if (!willAttemptReconnect && !this.disconnecting) {
      this.consumer?.disconnect();
      this.consumer = this.fieldKeysWs = null;
      this.wsAttemptConnect();
      this.connected = false;
    }
  }

  onWsReceive({ token, results }) {
    this.wsReconnectAttempts = 0;
    if (results.length === 0) return;
    this.fieldLookUpCb({ token, results });
  }

  cancelReconnectTimeout() {
    if (this.reconnectTimeoutID !== null) {
      clearTimeout(this.reconnectTimeoutID);
      this.reconnectTimeoutID = null;
    }
  }
}
